import { cleanArray, TableColumn } from '@arnold/common';
import { TFunction } from 'react-i18next';
import { ParticipantDetailData } from './types';

export const getColumns = (t: TFunction, isOnboarding?: boolean): Array<TableColumn<ParticipantDetailData>> =>
  cleanArray([
    {
      key: 'sentAt',
      title: t('sentAt'),
      dataIndex: 'sentAt',
    },
    {
      key: 'topicGroupName',
      title: t('topicGroupName'),
      dataIndex: 'topicGroupName',
    },
    !!isOnboarding && {
      key: 'feeling',
      title: t('feeling'),
      dataIndex: 'feeling',
    },
    {
      key: 'resend',
      title: '',
      dataIndex: 'resend',
    },
  ]);
